import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IRecordFurtherEducationEditItem extends IEditItem {
    groupId: string;
    code: string;
    comment: string;
    scopeUnit: number;
    scope: number;
    validity: number;
    modifyUser: IModifyUser;
}

export class RecordFurtherEducationEditItem extends EditItem implements IRecordFurtherEducationEditItem {
    groupId: string;
    code: string;
    comment: string;
    scopeUnit: number;
    scope: number;
    validity: number;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IRecordFurtherEducationEditItem);
    constructor(obj?: any) {
        super(obj);
        this.groupId = obj && obj.groupId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.scopeUnit = obj && obj.scopeUnit || 0;
        this.scope = obj && obj.scope || 0;
        this.validity = obj && obj.validity || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}